import { Product, ProductPrice, Titration } from "src/api/types";

const monthToProduct: Record<string, string> = {
  "Weight Loss-1": "Monthly",
};

export const priceOptionLabel = (
  price: ProductPrice | undefined,
  titration: Titration | undefined,
  product: Product | null,
) => {
  if (price == null) return "";

  const recommendedPrice = titration?.price_id === price.id ? "⭐" : "";

  const doseRange =
    price?.titration?.[0] != null
      ? `; ${price.titration[0].min_dose} to ${price.titration[0].max_dose}${price.titration[0].dose_unit}/week`
      : "";

  return `${recommendedPrice} ${price.name} ${
    monthToProduct[`${product?.category.name}-${price.number_of_months}`] ?? ""
  }${doseRange} - $${price.amount}`;
};
